import { ActionTree } from 'vuex'

import { updateDraft } from '@/sdk/clients/ServicesRequest'
import logger from '@/sdk/logger'
import { UpdateEvent } from '@/store/booking-funnel/types'
import { RootState } from '@/store/types'

import { Mutations, PaymentDTO, PaymentPageData, PaymentState } from './types'

const actions: ActionTree<PaymentState, RootState> = {
  async submitPayment(
    { rootState },
    paymentPayload: UpdateEvent<'payment', PaymentDTO>,
  ): Promise<void> {
    const draftUuid = rootState.registration.serviceRequestDraftId

    try {
      await updateDraft(paymentPayload, draftUuid)
    } catch (error) {
      logger.error('failed saving the payment data', {
        error,
        tags: ['bookingFunnel', 'http', 'payment', 'step4'],
      })

      throw error
    }
  },

  setPaymentFromBE({ commit }, payment: PaymentDTO) {
    commit(Mutations.SET_PAYMENT_FROM_BE, payment)
  },

  setPaymentPageData({ commit }, payment: PaymentPageData) {
    commit(Mutations.SET_PAYMENT_PAGE_DATA, payment)
  },
}

export default actions
